import { IHistorySeries } from '../models/series-point.model';
import { INpsSummary } from '../models/nps-summary.model';

/** Fila de la tabla "NPS SUCURSAL" del Home. */
export interface ISucursalNps {
  sucursal: string;
  nps: number;
}

/** Categoria de la barra apilada "Drivers de recomendacion". */
export interface IDriver {
  name: string;
  value: number;
}

/* -------------------------------------------------------------------------- */
/*                              ANCHOR resumenes                              */
/* -------------------------------------------------------------------------- */

export const NPS_GENERAL: INpsSummary = {
  nps: 74, detractor: 5, pasivo: 16, promotor: 79, period: 'Agosto/2026',
};

export const NPS_COMERCIANTE: INpsSummary = {
  nps: 69, detractor: 9, pasivo: 13, promotor: 78, period: 'Agosto/2026',
};

export const NPS_CONSUMIDOR: INpsSummary = {
  nps: 76, detractor: 5, pasivo: 14, promotor: 81, period: 'Agosto/2026',
};

export const PERIODO: string = 'Agosto/2026';

/* -------------------------------------------------------------------------- */
/*                             ANCHOR NPS MENSUAL                             */
/* -------------------------------------------------------------------------- */

/**
 * 13 meses (Ago-25 -> Ago-26). YTD = acumulado del ano, Rolling = ventana movil
 * de doce meses. Agosto va a la mitad: el corte es el 11 de 31, y por eso
 * su conteo cae respecto a julio sin que el NPS se mueva.
 */
export const NPS_MENSUAL: IHistorySeries = {
  ytd: [
    { label: 'Ago-25', value: 63,  count: 43655 },
    { label: 'Sep-25', value: 63,  count: 50605 },
    { label: 'Oct-25', value: 63,  count: 58025 },
    { label: 'Nov-25', value: 64,  count: 65835 },
    { label: 'Dic-25', value: 64,  count: 74095 },
    { label: 'Ene-26', value: 66,  count: 6130 },
    { label: 'Feb-26', value: 68,  count: 13180 },
    { label: 'Mar-26', value: 68,  count: 20870 },
    { label: 'Abr-26', value: 69,  count: 28890 },
    { label: 'May-26', value: 69,  count: 36370 },
    { label: 'Jun-26', value: 70,  count: 44680 },
    { label: 'Jul-26', value: 70,  count: 53320 },
    { label: 'Ago-26', value: 70,  count: 56468 },
  ],
  rolling: [
    { label: 'Ago-25', value: 63,  count: 7240 },
    { label: 'Sep-25', value: 63,  count: 6950 },
    { label: 'Oct-25', value: 63,  count: 7420 },
    { label: 'Nov-25', value: 64,  count: 7810 },
    { label: 'Dic-25', value: 64,  count: 8260 },
    { label: 'Ene-26', value: 64,  count: 6130 },
    { label: 'Feb-26', value: 65,  count: 7050 },
    { label: 'Mar-26', value: 66,  count: 7690 },
    { label: 'Abr-26', value: 66,  count: 8020 },
    { label: 'May-26', value: 67,  count: 7480 },
    { label: 'Jun-26', value: 68,  count: 8310 },
    { label: 'Jul-26', value: 68,  count: 8640 },
    { label: 'Ago-26', value: 69,  count: 3148 },
  ],
};

/* -------------------------------------------------------------------------- */
/*                           ANCHOR historicos NPS                            */
/* -------------------------------------------------------------------------- */

export const HISTORICO_COMERCIANTE: IHistorySeries = {
  ytd: [
    { label: 'Ago-25', value: 58,  count: 14843 },
    { label: 'Sep-25', value: 59,  count: 17206 },
    { label: 'Oct-25', value: 59,  count: 19729 },
    { label: 'Nov-25', value: 59,  count: 22384 },
    { label: 'Dic-25', value: 60,  count: 25192 },
    { label: 'Ene-26', value: 62,  count: 2084 },
    { label: 'Feb-26', value: 63,  count: 4481 },
    { label: 'Mar-26', value: 64,  count: 7096 },
    { label: 'Abr-26', value: 65,  count: 9823 },
    { label: 'May-26', value: 65,  count: 12366 },
    { label: 'Jun-26', value: 65,  count: 15191 },
    { label: 'Jul-26', value: 66,  count: 18129 },
    { label: 'Ago-26', value: 66,  count: 19199 },
  ],
  rolling: [
    { label: 'Ago-25', value: 58,  count: 2462 },
    { label: 'Sep-25', value: 59,  count: 2363 },
    { label: 'Oct-25', value: 59,  count: 2523 },
    { label: 'Nov-25', value: 59,  count: 2655 },
    { label: 'Dic-25', value: 60,  count: 2808 },
    { label: 'Ene-26', value: 60,  count: 2084 },
    { label: 'Feb-26', value: 61,  count: 2397 },
    { label: 'Mar-26', value: 61,  count: 2615 },
    { label: 'Abr-26', value: 62,  count: 2727 },
    { label: 'May-26', value: 63,  count: 2543 },
    { label: 'Jun-26', value: 63,  count: 2825 },
    { label: 'Jul-26', value: 64,  count: 2938 },
    { label: 'Ago-26', value: 65,  count: 1070 },
  ],
};

export const HISTORICO_CONSUMIDOR: IHistorySeries = {
  ytd: [
    { label: 'Ago-25', value: 65,  count: 28812 },
    { label: 'Sep-25', value: 65,  count: 33399 },
    { label: 'Oct-25', value: 66,  count: 38296 },
    { label: 'Nov-25', value: 66,  count: 43451 },
    { label: 'Dic-25', value: 66,  count: 48903 },
    { label: 'Ene-26', value: 68,  count: 4046 },
    { label: 'Feb-26', value: 70,  count: 8699 },
    { label: 'Mar-26', value: 71,  count: 13774 },
    { label: 'Abr-26', value: 71,  count: 19067 },
    { label: 'May-26', value: 71,  count: 24004 },
    { label: 'Jun-26', value: 72,  count: 29489 },
    { label: 'Jul-26', value: 73,  count: 35191 },
    { label: 'Ago-26', value: 73,  count: 37269 },
  ],
  rolling: [
    { label: 'Ago-25', value: 65,  count: 4778 },
    { label: 'Sep-25', value: 65,  count: 4587 },
    { label: 'Oct-25', value: 66,  count: 4897 },
    { label: 'Nov-25', value: 66,  count: 5155 },
    { label: 'Dic-25', value: 66,  count: 5452 },
    { label: 'Ene-26', value: 67,  count: 4046 },
    { label: 'Feb-26', value: 67,  count: 4653 },
    { label: 'Mar-26', value: 68,  count: 5075 },
    { label: 'Abr-26', value: 69,  count: 5293 },
    { label: 'May-26', value: 69,  count: 4937 },
    { label: 'Jun-26', value: 70,  count: 5485 },
    { label: 'Jul-26', value: 71,  count: 5702 },
    { label: 'Ago-26', value: 71,  count: 2078 },
  ],
};

/* -------------------------------------------------------------------------- */
/*                      ANCHOR drivers de recomendacion                       */
/* -------------------------------------------------------------------------- */

/** Los ocho motivos declarados; suman 100. */
export const DRIVERS_RECOMENDACION: Array<IDriver> = [
  { name: 'EXPERIENCIA DE PRODUCTOS',                      value: 23 },
  { name: 'EXPERIENCIA DE PRODUCTOS EN CREMERÍA',          value: 5 },
  { name: 'EXPERIENCIA EN TIENDA',                         value: 11 },
  { name: 'PERCEPCIÓN DE LOS PRECIOS',                     value: 13 },
  { name: 'PROMOCIONES',                                   value: 7 },
  { name: 'PROTOCOLOS DE ATENCIÓN A CLIENTE',              value: 34 },
  { name: 'PROTOCOLOS DE ATENCIÓN A CLIENTE EN CREMERÍA',  value: 6 },
  { name: 'SEGURIDAD EN TIENDA',                           value: 1 },
];

/* -------------------------------------------------------------------------- */
/*                          ANCHOR NPS por sucursal                           */
/* -------------------------------------------------------------------------- */

/**
 * 145 sucursales -> 15 paginas de 10 registros, como el DataTable original.
 * El NPS de cada una sale de `npsDeSucursal()`, así que la misma tienda trae la
 * misma cifra aquí, en el ranking de Explorar y en el CSAT por tienda.
 */
export const NPS_SUCURSALES: Array<ISucursalNps> = [
  { sucursal: 'SUCURSAL CUAUHTEMOC',                nps: 95 },
  { sucursal: 'SUCURSAL TULANCINGO',                nps: 95 },
  { sucursal: 'SUCURSAL APAN',                      nps: 94 },
  { sucursal: 'SUCURSAL QUERETARO CENTRO',          nps: 94 },
  { sucursal: 'SUCURSAL ACAPULCO COSTERA',          nps: 93 },
  { sucursal: 'SUCURSAL METZTITLAN',                nps: 92 },
  { sucursal: 'SUCURSAL TEPATITLAN',                nps: 92 },
  { sucursal: 'SUCURSAL TULTITLAN',                 nps: 92 },
  { sucursal: 'SUCURSAL CUERNAVACA CENTRO',         nps: 91 },
  { sucursal: 'SUCURSAL TENANCINGO',                nps: 91 },
  { sucursal: 'SUCURSAL TIZAYUCA',                  nps: 91 },
  { sucursal: 'SUCURSAL ALVARO OBREGON',            nps: 90 },
  { sucursal: 'SUCURSAL CUAJIMALPA',                nps: 90 },
  { sucursal: 'SUCURSAL TONALA',                    nps: 89 },
  { sucursal: 'SUCURSAL XOCHITEPEC',                nps: 89 },
  { sucursal: 'SUCURSAL DOLORES HIDALGO',           nps: 88 },
  { sucursal: 'SUCURSAL PUERTO VALLARTA',           nps: 88 },
  { sucursal: 'SUCURSAL QUERETARO SUR',             nps: 88 },
  { sucursal: 'SUCURSAL EMILIANO ZAPATA',           nps: 87 },
  { sucursal: 'SUCURSAL VALLE DE SANTIAGO',         nps: 87 },
  { sucursal: 'SUCURSAL AMEALCO',                   nps: 86 },
  { sucursal: 'SUCURSAL ARANDAS',                   nps: 86 },
  { sucursal: 'SUCURSAL ARCELIA',                   nps: 86 },
  { sucursal: 'SUCURSAL OCOTLAN',                   nps: 85 },
  { sucursal: 'SUCURSAL TEPEAPULCO',                nps: 85 },
  { sucursal: 'SUCURSAL ACAMBARO',                  nps: 84 },
  { sucursal: 'SUCURSAL AMECAMECA',                 nps: 84 },
  { sucursal: 'SUCURSAL CHILPANCINGO',              nps: 84 },
  { sucursal: 'SUCURSAL EL MARQUES',                nps: 84 },
  { sucursal: 'SUCURSAL MAGDALENA CONTRERAS',       nps: 84 },
  { sucursal: 'SUCURSAL SANTIAGO TULANTEPEC',       nps: 84 },
  { sucursal: 'SUCURSAL HUICHAPAN',                 nps: 83 },
  { sucursal: 'SUCURSAL LAGOS DE MORENO',           nps: 83 },
  { sucursal: 'SUCURSAL SAN SALVADOR',              nps: 83 },
  { sucursal: 'SUCURSAL ZACUALTIPAN',               nps: 83 },
  { sucursal: 'SUCURSAL ZIMAPAN',                   nps: 83 },
  { sucursal: 'SUCURSAL IZTAPALAPA',                nps: 82 },
  { sucursal: 'SUCURSAL AUTLAN',                    nps: 81 },
  { sucursal: 'SUCURSAL TIZAYUCA II',               nps: 80 },
  { sucursal: 'SUCURSAL TLALPAN',                   nps: 80 },
  { sucursal: 'SUCURSAL ZUMPANGO',                  nps: 80 },
  { sucursal: 'SUCURSAL ATIZAPAN 2',                nps: 79 },
  { sucursal: 'SUCURSAL GUANAJUATO CAPITAL',        nps: 79 },
  { sucursal: 'SUCURSAL MILPA ALTA',                nps: 79 },
  { sucursal: 'SUCURSAL CHAPALA',                   nps: 78 },
  { sucursal: 'SUCURSAL OMITLAN',                   nps: 78 },
  { sucursal: 'SUCURSAL PACHUCA CENTRO',            nps: 78 },
  { sucursal: 'SUCURSAL ATIZAPAN',                  nps: 77 },
  { sucursal: 'SUCURSAL CHIMALHUACAN',              nps: 77 },
  { sucursal: 'SUCURSAL ECATEPEC',                  nps: 77 },
  { sucursal: 'SUCURSAL MIXQUIAHUALA',              nps: 77 },
  { sucursal: 'SUCURSAL CIUDAD GUZMAN',             nps: 76 },
  { sucursal: 'SUCURSAL IGUALA',                    nps: 76 },
  { sucursal: 'SUCURSAL IXTAPALUCA',                nps: 76 },
  { sucursal: 'SUCURSAL PUENTE DE IXTLA',           nps: 76 },
  { sucursal: 'SUCURSAL TEQUISQUIAPAN',             nps: 76 },
  { sucursal: 'SUCURSAL TULANCINGO ORIENTE',        nps: 76 },
  { sucursal: 'SUCURSAL ACAPULCO DIAMANTE',         nps: 75 },
  { sucursal: 'SUCURSAL ALTA TENSION 2',            nps: 75 },
  { sucursal: 'SUCURSAL GUADALAJARA NORTE',         nps: 75 },
  { sucursal: 'SUCURSAL MARIANO ESCOBEDO LEON',     nps: 75 },
  { sucursal: 'SUCURSAL PACHUCA NORTE',             nps: 75 },
  { sucursal: 'SUCURSAL PROGRESO DE OBREGON',       nps: 75 },
  { sucursal: 'SUCURSAL SAN JUAN DEL RIO',          nps: 75 },
  { sucursal: 'SUCURSAL TENANGO DE DORIA',          nps: 75 },
  { sucursal: 'SUCURSAL VENUSTIANO CARRANZA',       nps: 75 },
  { sucursal: 'SUCURSAL XOCHIMILCO',                nps: 75 },
  { sucursal: 'SUCURSAL ACTOPAN',                   nps: 74 },
  { sucursal: 'SUCURSAL ATOTONILCO EL GRANDE',      nps: 74 },
  { sucursal: 'SUCURSAL HUEHUETOCA',                nps: 74 },
  { sucursal: 'SUCURSAL HUEJUTLA',                  nps: 74 },
  { sucursal: 'SUCURSAL LA PAZ',                    nps: 74 },
  { sucursal: 'SUCURSAL TLALNEPANTLA',              nps: 74 },
  { sucursal: 'SUCURSAL VALLE DE BRAVO',            nps: 74 },
  { sucursal: 'SUCURSAL ATLACOMULCO',               nps: 73 },
  { sucursal: 'SUCURSAL COACALCO',                  nps: 73 },
  { sucursal: 'SUCURSAL GUSTAVO A MADERO',          nps: 73 },
  { sucursal: 'SUCURSAL IRAPUATO',                  nps: 73 },
  { sucursal: 'SUCURSAL MOLANGO',                   nps: 73 },
  { sucursal: 'SUCURSAL TAXCO',                     nps: 73 },
  { sucursal: 'SUCURSAL TLAXCOAPAN',                nps: 73 },
  { sucursal: 'SUCURSAL TOLUCA 1',                  nps: 73 },
  { sucursal: 'SUCURSAL TOLUCA CENTRO',             nps: 73 },
  { sucursal: 'SUCURSAL CIUDAD SAHAGUN',            nps: 72 },
  { sucursal: 'SUCURSAL IXTLAHUACA',                nps: 72 },
  { sucursal: 'SUCURSAL JACALA',                    nps: 72 },
  { sucursal: 'SUCURSAL MINERAL DE LA REFORMA',     nps: 72 },
  { sucursal: 'SUCURSAL SINGUILUCAN',               nps: 72 },
  { sucursal: 'SUCURSAL IGUALA 2',                  nps: 71 },
  { sucursal: 'SUCURSAL NEZAHUALCOYOTL',            nps: 71 },
  { sucursal: 'SUCURSAL TLAJOMULCO',                nps: 71 },
  { sucursal: 'SUCURSAL NAUCALPAN',                 nps: 70 },
  { sucursal: 'SUCURSAL PEDRO ESCOBEDO',            nps: 70 },
  { sucursal: 'SUCURSAL CELAYA',                    nps: 69 },
  { sucursal: 'SUCURSAL NICOLAS ROMERO',            nps: 69 },
  { sucursal: 'SUCURSAL ZINACANTEPEC',              nps: 69 },
  { sucursal: 'SUCURSAL JIUTEPEC',                  nps: 68 },
  { sucursal: 'SUCURSAL TOLUCA NORTE',              nps: 68 },
  { sucursal: 'SUCURSAL ZAPOPAN',                   nps: 68 },
  { sucursal: 'SUCURSAL CUAUTLA',                   nps: 67 },
  { sucursal: 'SUCURSAL PACHUCA SUR',               nps: 67 },
  { sucursal: 'SUCURSAL SALAMANCA',                 nps: 67 },
  { sucursal: 'SUCURSAL TEXCOCO',                   nps: 67 },
  { sucursal: 'SUCURSAL CHALCO',                    nps: 66 },
  { sucursal: 'SUCURSAL COYUCA',                    nps: 66 },
  { sucursal: 'SUCURSAL CUAUTITLAN IZCALLI',        nps: 66 },
  { sucursal: 'SUCURSAL EZEQUIEL MONTES',           nps: 66 },
  { sucursal: 'SUCURSAL IXMIQUILPAN',               nps: 66 },
  { sucursal: 'SUCURSAL PENJAMO',                   nps: 66 },
  { sucursal: 'SUCURSAL SILAO',                     nps: 66 },
  { sucursal: 'SUCURSAL TECAMAC',                   nps: 66 },
  { sucursal: 'SUCURSAL CADEREYTA',                 nps: 65 },
  { sucursal: 'SUCURSAL CUERNAVACA NORTE',          nps: 65 },
  { sucursal: 'SUCURSAL ECATEPEC NORTE',            nps: 64 },
  { sucursal: 'SUCURSAL COYOACAN',                  nps: 63 },
  { sucursal: 'SUCURSAL TEMIXCO',                   nps: 63 },
  { sucursal: 'SUCURSAL VALLE DE CHALCO',           nps: 63 },
  { sucursal: 'SUCURSAL MOROLEON',                  nps: 62 },
  { sucursal: 'SUCURSAL AMECA',                     nps: 61 },
  { sucursal: 'SUCURSAL TASQUILLO',                 nps: 61 },
  { sucursal: 'SUCURSAL GUADALAJARA CENTRO',        nps: 60 },
  { sucursal: 'SUCURSAL IZTAPALAPA ORIENTE',        nps: 60 },
  { sucursal: 'SUCURSAL LEON ORIENTE',              nps: 60 },
  { sucursal: 'SUCURSAL TULA DE ALLENDE',           nps: 60 },
  { sucursal: 'SUCURSAL SAN MIGUEL DE ALLENDE',     nps: 59 },
  { sucursal: 'SUCURSAL TLAHUAC',                   nps: 59 },
  { sucursal: 'SUCURSAL TLAPA',                     nps: 59 },
  { sucursal: 'SUCURSAL ZACATEPEC',                 nps: 59 },
  { sucursal: 'SUCURSAL AZCAPOTZALCO',              nps: 58 },
  { sucursal: 'SUCURSAL OMETEPEC',                  nps: 58 },
  { sucursal: 'SUCURSAL LERMA',                     nps: 57 },
  { sucursal: 'SUCURSAL AJACUBA',                   nps: 56 },
  { sucursal: 'SUCURSAL LEON CENTRO',               nps: 56 },
  { sucursal: 'SUCURSAL MINERAL DEL MONTE',         nps: 56 },
  { sucursal: 'SUCURSAL SAN LUIS DE LA PAZ',        nps: 56 },
  { sucursal: 'SUCURSAL TLAQUEPAQUE',               nps: 56 },
  { sucursal: 'SUCURSAL ZIHUATANEJO',               nps: 56 },
  { sucursal: 'SUCURSAL CORREGIDORA',               nps: 55 },
  { sucursal: 'SUCURSAL TEJUPILCO',                 nps: 54 },
  { sucursal: 'SUCURSAL METEPEC',                   nps: 51 },
  { sucursal: 'SUCURSAL LEON 2',                    nps: 50 },
  { sucursal: 'SUCURSAL YAUTEPEC',                  nps: 50 },
  { sucursal: 'SUCURSAL IZTACALCO',                 nps: 49 },
  { sucursal: 'SUCURSAL TEPEJI DEL RIO',            nps: 48 },
  { sucursal: 'SUCURSAL SAN FRANCISCO DEL RINCON',  nps: 41 },
];
